module.exports = __webpack_public_path__ + "93155a1a0822abcf23f666ca9d8ac8ce.jpg";